import React from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

const COLORS = {
  cognitive: "#edebf3", sleep: "#ffdadb", physical: "#ffdcaf",
  emotional: "#fff3c4", speech: "#cef3c4", vision: "#c1fdf7",
};

const tSymptomName = (t, subcategory, factor) => {
  const safe = (factor || "").trim().toLowerCase()
    .replace(/ /g, "_").replace(/\//g, "_").replace(/,/g, "")
    .replace(/:/g, "").replace(/'/g, "").replace(/[()]/g, "").replace(/-/g, "_")
    .substring(0, 60);
  const key = `symptom.${subcategory}.${safe}`;
  const translated = t(key);
  return translated !== key ? translated : factor;
};

const TopThreeSymptomsPreview = ({ worstSymptoms, topSymptoms }) => {
  const { t } = useTranslation();
  const list = worstSymptoms && worstSymptoms.length > 0 ? worstSymptoms : topSymptoms;
  if (!list || list.length === 0) return null;

  return (
    <div
      className="d-flex flex-row justify-content-center"
      style={{
        gap: "0.35rem",
        marginTop: "0.5rem",
        width: "100%",
        minWidth: 0,
        flexWrap: "wrap",
        boxSizing: "border-box",
      }}
    >
      {list.slice(0, 3).map((s, i) => (
        <span
          key={s.factor || i}
          style={{
            background: COLORS[s.subcategory] || "#f4f3ee",
            border: "1px solid #106995",
            color: "#1a1a1a",
            borderRadius: "999px",
            padding: "0.28rem 0.75rem",
            fontSize: "12px",
            fontWeight: 600,
            maxWidth: "150px",
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.3",
            textAlign: "center",
          }}
        >
          {tSymptomName(t, s.subcategory, s.factor)}
        </span>
      ))}
    </div>
  );
};

export default TopThreeSymptomsPreview;